/**
 * App router
 * @module Router
 */

import Vue from 'vue'
import Router from 'vue-router'
import lang from './lang'

import index from '@/pages/index'
import help from '@/pages/help'
import alphanumericId from '@/pages/alphanumeric-id'
import releasesFormat from '@/pages/releases-format'
import bandsId from '@/pages/bands-id'
import artistsId from '@/pages/artists-id'
import labelsName from '@/pages/labels-name'
import albumsId from '@/pages/albums-id'
import api from '@/pages/api'

import genres from '@/pages/genres'
import genresGenre from '@/pages/genres-genre'

import years from '@/pages/years'
import yearsRange from '@/pages/years-range'

import regions from '@/pages/regions'
import regionsRegion from '@/pages/regions-region'

/**
 * Static routes
 * @array
 */
const routes = [{
  path: '/',
  name: 'index',
  component: index,
  nav: true,
  label: lang.start,
  icon: 'mdi-home'
}, {
  path: '/alphanumeric',
  name: 'alphanumeric',
  nav: true,
  nested: 'alphanumeric',
  label: lang.alpha,
  icon: 'mdi-alphabetical',
  redirect: {
    path: '/alphanumeric/А'
  }
}, {
  path: '/genres',
  name: 'genres',
  component: genres,
  nav: true,
  nested: 'genres',
  label: lang.genres,
  icon: 'mdi-guitar-electric'
}, {
  path: '/years',
  name: 'years',
  component: years,
  nav: true,
  nested: 'years',
  label: lang.years,
  icon: 'mdi-calendar'
}, {
  path: '/regions',
  name: 'regions',
  component: regions,
  nav: true,
  nested: 'regions',
  label: lang.byRegion,
  icon: 'mdi-map-marker'
}, {
  path: '/releases',
  name: 'releases',
  nav: true,
  nested: 'releases',
  label: lang.releases,
  icon: 'mdi-disk',
  redirect: {
    path: '/releases/Албум'
  }
}, {
  path: '/help',
  name: 'help',
  component: help,
  nav: true,
  label: lang.help,
  icon: 'mdi-help-circle-outline'
}, {
  path: '/bands',
  name: 'bands',
  redirect: {
    path: '/bands/1'
  }
}, {
  path: '/bands/:id',
  name: 'bands-id',
  component: bandsId
}, {
  path: '/albums',
  name: 'albums',
  redirect: {
    path: '/albums/1'
  }
}, {
  path: '/albums/:id',
  name: 'albums-id',
  component: albumsId
}, {
  path: '/artists',
  name: 'artists',
  redirect: {
    path: '/artists/1'
  }
}, {
  path: '/artists/:id',
  name: 'artists-id',
  component: artistsId
}, {
  path: '/alphanumeric/:id',
  name: 'alphanumeric-id',
  component: alphanumericId
}, {
  path: '/genres/:genre',
  name: 'genres-genre',
  component: genresGenre
}, {
  path: '/years/:range',
  name: 'years-range',
  component: yearsRange
}, {
  path: '/regions/:region',
  name: 'regions-region',
  component: regionsRegion
}, {
  path: '/releases/:format',
  name: 'releases-format',
  component: releasesFormat
}, {
  path: '/labels',
  name: 'labels',
  redirect: {
    path: '/labels/Balkanton'
  }
}, {
  path: '/labels/:name',
  name: 'labels-name',
  component: labelsName
}, {
  path: '/api',
  name: 'api',
  component: api
}]

Vue.use(Router)

export default new Router({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/helpers/router.js